import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LocalizationProvider } from './contexts/LocalizationContext';
import { Footer } from './components/Footer';
import { lazyWithRetry } from './utils/lazyWithRetry';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const ContentDetailPage = lazyWithRetry(() => import('./pages/ContentDetailPage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const TMDBSearchPage = lazy(() => import('./pages/TMDBSearchPage'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen bg-gray-900 text-white">
    {/* Empty loading state - no spinner or messages */}
  </div>
);

function App() {
  //console.log('📱 App component: Initializing');
  //console.log('🗺️ Current location:', window.location.href);

  try {
    return (
      <LocalizationProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <div className="min-h-screen bg-gray-900 text-white flex flex-col">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/content/:id" element={<ContentDetailPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/tmdb-search" element={<TMDBSearchPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </Router>
      </LocalizationProvider>
    );
  } catch (error) {
    console.error('🚨 App component error:', error);
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-4">❌</div>
          <div className="text-xl font-bold text-red-400 mb-2">App Error</div>
          <div className="text-gray-400">Check console for details</div>
        </div>
      </div>
    );
  }
}

export default App;